import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

import { useViralLoops } from '../ReferralProvider/hooks';

interface ReferralButtonProps extends Omit<ComponentProps<'button'>, 'children'> {}

const ReferralButton = ({ className, onClick, ...props }: ReferralButtonProps) => {
  const viralLoops = useViralLoops();

  if (!viralLoops) return null;

  return (
    <button
      type="button"
      className={cn(
        'preflight preflight-button',
        'inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-medium text-white transition-colors duration-200',
        'bg-primary-green hover:bg-secondary-green',
        className,
      )}
      onClick={(e) => {
        viralLoops
          .getCampaign()
          .then((campaign) => {
            campaign?.openModal();
          })
          .catch((error) => {
            console.error(error);
          });
        onClick?.(e);
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <FontAwesomeIcon icon={faStar} className="text-sm" />
      <span>Invite & Earn</span>
    </button>
  );
};

export default ReferralButton;
